import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Button } from "react-bootstrap";
import axios from "axios";
import apiUrl from "slices/apiEndpoint";
import { selectSavedCards, selectSpinerLoading, selectUserDetails, setSpinnerLoading } from "slices/userProfile/reducer";
import decodeJwt from "helpers/jwt-token-access/jwtdecode";
import { getDecodeId } from "slices/userProfile/thunk";
import { DialogDescription } from "components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "components/ui/tabs";
import { Check, CreditCard, Loader2, Plus } from "lucide-react";
import { RadioGroup, RadioGroupItem } from "components/ui/radio-group";
import { OutlineButton } from "components/ui/button";
import api from "Common/api";
import "./deluxe-subscription-modal.css";
type PaymentAction = "trial" | "payNow" | null;

declare const EmbeddedPayments: any;

type Props = {
  isOpen: boolean;
  onClose: () => void;
  plan: any;
  afterSubmit: () => void;
  trialEligible?: boolean;
};
function SavedCardsList({
  savedCard = [],
  onSubcribe,
  trialEligible,
  pendingAction,
  disabled,
}: {
  savedCard: any;
  onSubcribe: (c: any, isTrail?: any) => void;
  trialEligible: boolean;
  pendingAction: PaymentAction;
  disabled: boolean;
}) {
  const [selectedCard, setSelectedCard] = useState<string>(savedCard[0]?.paymentMethodId||"");

  return (
    <div className="space-y-4 ">
      <RadioGroup value={selectedCard} onValueChange={(value) => !disabled && setSelectedCard(value)}>
        {savedCard.map((card:any) => (
          <div
            key={card.id}
            className={`flex items-center space-x-4 rounded-lg border p-3 transition-colors ${disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"} ${
              selectedCard === card.paymentMethodId
                ? "border-secondary bg-gray-100"
                : "border-gray-200 hover:border-gray-300"
            }`}
            onClick={() => !disabled && setSelectedCard(card.paymentMethodId)}
          >
            <RadioGroupItem disabled={disabled} color="#060513" value={card.paymentMethodId} id={card.paymentMethodId} />
            <div className="flex-1 b ">
              <div className="flex items-center gap-2">
                <CreditCard className="w-5 h-5 text-gray-600" />
                <span className="font-medium">
                  {card.cardType}  {card.maskedPan}
                </span>
             
              </div>
              <div className="text-sm text-gray-500 ml-7">
                Expires {card.expiry}
              </div>
            </div>
            {selectedCard === card.paymentMethodId && (
              <Check className="w-5 h-5 text-secondary" />
            )}
          </div>
        ))}
      </RadioGroup>
      {trialEligible ? <OutlineButton aria-busy={pendingAction === "trial"} disabled={disabled || !selectedCard} onClick={()=>{
        onSubcribe(selectedCard,true)
      }} variant={'ghost'} className="deluxe-subscription-modal__action deluxe-subscription-modal__action--secondary w-full">
        {pendingAction === "trial" ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Processing trial...</> : "Subscribe with 30 days trial"}
      </OutlineButton> : null}

      <Button aria-busy={pendingAction === "payNow"} disabled={disabled || !selectedCard} onClick={()=>{
        onSubcribe(selectedCard)
      }} className="deluxe-subscription-modal__action deluxe-subscription-modal__action--primary w-full">
        {pendingAction === "payNow" ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Processing payment...</> : "Pay now & Start Subscription"}
      </Button>
    </div>
  );
}
const DeluxeSubscriptionModal: React.FC<Props> = ({
  isOpen,
  afterSubmit,
  onClose,
  plan,
  trialEligible = true,
}) => {
  const dispatch: any = useDispatch();
  const userId = getDecodeId();
  const decodedToken = decodeJwt();
  const userEmail = decodedToken?.email || "";
  const spinnerLaoding = useSelector(selectSpinerLoading)
  const user: any = useSelector(selectUserDetails);
  const [useSavedCard, setUseSavedCard] = useState(true);
  const [selectedTab,setSelectedTab]=useState("new")
  const [isTrail, setIsTrail] = useState(false);
  const [savedCard, setSavedCard] = useState<any>([]);
  const [refresh,setRefresh]=useState(false)
  const [sdkReady, setSdkReady] = useState(false);
  const [sdkRendered, setSdkRendered] = useState(false);
  const [jwt, setJwt] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const [pendingAction, setPendingAction] = useState<PaymentAction>(null);
  const initializedRef = useRef(false);
  const tokenSuccessCalledRef = useRef(false);
  const paymentActionRef = useRef<PaymentAction>(null);
  const clearPaymentAttempt = () => {
    paymentActionRef.current = null;
    setPendingAction(null);
  };
  const cardDetails = useSelector(selectSavedCards)

  // 1) Load saved card from backend
  useEffect(() => {
    if (!isOpen) {
      setSdkReady(false);
      setSdkRendered(false);
      initializedRef.current = false;
      tokenSuccessCalledRef.current = false;
      setJwt(null);
      clearPaymentAttempt();
      return
    }

    const loadSaved = async () => {
      try {
        setMessage(null);
        // const resp = await axios.post(`${apiUrl}/v2/api/deluxe/getSavedCards/`,{
        //   email:userEmail,
        //   userId:userId
        // }) as any
        // console.log(resp?.cards)
        const card = cardDetails||null
        // const card = resp?.cards || null;
        setSavedCard(card);
        if(card[0]){
          setSelectedTab("saved")

        }else{
          setUseSavedCard(false)
        }
        

        // if no saved card, force add new card
        if (!card) setUseSavedCard(false);
      } catch (e) {
        console.log("No saved card found");
        setSavedCard([]);
        setUseSavedCard(false);
      }
    };

    loadSaved();
  }, [isOpen]);
  // useEffect(() => {
  //   if (!sdkRendered) return;
  
  //   const interval = setInterval(() => {
  //     const container = document.getElementById("embeddedpayments");
  //     if (!container) return;
  
  //     const buttons = container.querySelectorAll("button");
  //     buttons.forEach((btn) => {
  //       console.log(btn)
  //       const txt = (btn.textContent || "").toLowerCase().trim();
  //       if (txt === "add card") {
  //         (btn as HTMLButtonElement).style.display = "none";
  //       }
  //     });
  //   }, 300);
  
  //   return () => clearInterval(interval);
  // }, [sdkRendered]);
  
  // 2) If Add New Card selected → create Deluxe JWT token-mode
  useEffect(() => {
    if (!isOpen) return;
    if (useSavedCard) return;

    const fetchJwt = async () => {
      dispatch(setSpinnerLoading("Please Wait..."));
      setMessage(null);
      setJwt(null);
      setSdkReady(false);
      initializedRef.current = false;

      try {
        const resp = await api.post(`/v2/api/deluxe/create-jwt`, {
          userId,
          email: userEmail,
        }) as any

        if (!resp?.jwt) throw new Error("JWT missing");
        setJwt(resp.jwt);
      } catch (err) {
        console.error("Deluxe JWT error", err);
        setMessage("Unable to initialize card form. Please try again.");
        setTimeout(() => {
          setMessage("")
        }, 5000);
      } finally {
        dispatch(setSpinnerLoading(false));
      }
    };

    fetchJwt();
  }, [useSavedCard, isOpen]);
console.log(useSavedCard)
  // 3) Init Deluxe Embedded only when jwt exists and Add New Card mode
  useEffect(() => {
    console.log(jwt)
    if (!jwt) return;
    if (useSavedCard) return;
  
    if (typeof EmbeddedPayments === "undefined") {
      console.warn("Deluxe SDK not loaded yet");
      setSdkReady(false);
      setSdkRendered(false);
      return;
    }else{
      console.log(EmbeddedPayments)
    }
  
    // container must exist
    const container = document.getElementById("embeddedpayments");
    if (!container) {
      setSdkReady(false);
      setSdkRendered(false);
      return;
    }
  
    if (initializedRef.current) return;
    initializedRef.current = true;
  
    setSdkReady(true);
    setSdkRendered(false);
  
    EmbeddedPayments.init(jwt, {
      countryCode: "US",
      currencyCode: "USD",
      paymentMethods: ["cc"],
  
      collectBillingAddress: false,
      collectShippingAddress: false,
      requireBillingAddress: false,
  
      skipSellerStatusCheck: true,
      skipCompleteAuthorization: true,
    })
      .then((instance: any) => {
        instance
          .setEventHandlers({
            onTxnSuccess: () => {},
            onTxnFailed: clearPaymentAttempt,
            onTxnAuthorized: () => {},
            onValidationError: (_g: any, errs: any) => {
              console.log("Validation Error", errs);
              clearPaymentAttempt();
            },
            onCancel: clearPaymentAttempt,
  

            onTokenSuccess: async (_gateway: string, data: any) => {
              // ✅ stop duplicate triggers
              if (tokenSuccessCalledRef.current) return;
              tokenSuccessCalledRef.current = true;
              if (!paymentActionRef.current) {
                const fallbackAction: PaymentAction = isTrailRef.current ? "trial" : "payNow";
                paymentActionRef.current = fallbackAction;
                setPendingAction(fallbackAction);
              }
              console.log(data)
              console.log(_gateway)
            
              const token = data?.Token || data?.token;
              const expiry = data?.ExpMonthYear || data?.expiry;
            
              if (!token || !expiry) {
                tokenSuccessCalledRef.current = false; // allow retry
                clearPaymentAttempt();
                setTimeout(() => {
                  setMessage("")
                  setMessage(null);
                }, 5000);
                setMessage("Token not received properly. Try again.");
                return;
              }
            
              try {
                setMessage(null);
                await api.post(`/v2/api/deluxe/save-token-and-subscribe`, {
                  userId,
                  email: userEmail,
                  planType: plan?.plan_type || plan?.type || plan?.plan,
                  token,
                  expiry,
                  isTrail:isTrailRef.current
                }).then(()=>{
                  afterSubmit?.();
                onClose();
                })
            
                
              } catch (e: any) {
                console.error("save-token-and-subscribe error:", e);
                tokenSuccessCalledRef.current = false; // allow retry
                setTimeout(() => {
                  setMessage("")
                }, 5000);
                setMessage(e?.response?.data?.message || "Failed to subscribe. Try again.");
              } finally {
                clearPaymentAttempt();
              }
            },
  
            onTokenFailed: () => {
              tokenSuccessCalledRef.current = false;
              clearPaymentAttempt();
              setTimeout(() => {
                setMessage("")
              }, 5000);
              setMessage("Unable to tokenize card. Please try again.");
            },
          })
          .render({
            containerId: "embeddedpayments",
            paymentpanelstyle: "light",
            paybuttoncolor: "#2563eb",
            cancelbuttoncolor: "#ef4444",
          });
  
        // ✅ after render call -> show form
        setTimeout(() => {
          setSdkRendered(true);
        }, 150);
      })
      .catch((e: any) => {
        console.error("EmbeddedPayments init error:", e);
        setTimeout(() => {
        setMessage("");
          
        }, 5000);
        setMessage("Unable to load card form. Please refresh and try again.");
        setSdkRendered(false);
      });
  }, [jwt, useSavedCard,isTrail]);
  
  useEffect(() => {
    if (useSavedCard) {
      setSdkReady(false);
      setSdkRendered(false);
      initializedRef.current = false;
  
      const container = document.getElementById("embeddedpayments");
      if (container) container.innerHTML = "";
    }
  }, [useSavedCard,refresh]);
  
  // 4) Subscribe with saved card
  const subscribeWithSavedCard = async (paymentId?:any,isTrail?:any) => {
    if (!paymentId) {
      setMessage("No saved card found. Please add a new card.");
      setUseSavedCard(false);
      setTimeout(() => {
        setMessage("")
      }, 5000);
      return;
    }

    if (paymentActionRef.current) return;
    const action: PaymentAction = isTrail ? "trial" : "payNow";
    paymentActionRef.current = action;
    setPendingAction(action);

    try {
      setMessage(null);
     const selectedCard = savedCard.find((s:any)=>s.paymentMethodId===paymentId)
      await api.post(`/v2/api/deluxe/save-token-and-subscribe`, {
        userId,
        email: userEmail,
        planType: plan?.plan_type || plan?.type || plan?.plan,
        paymentMethodId:paymentId,
        expiry:selectedCard.expiry,
        isTrail:isTrail?isTrail:false
      }).then((e)=>{
        afterSubmit?.();
        onClose();
      }).catch((e)=>{
        console.log(e)
        setMessage(e?.responseMessage || "Subscription failed.");
        setTimeout(() => {
          setMessage("")
        }, 5000);

      })

    
    } catch (e: any) {
      console.error("subscribe-with-saved error:", e);
    } finally {
      clearPaymentAttempt();

    }
  };
  useEffect(() => {
    tokenSuccessCalledRef.current = false;
  }, [useSavedCard]);
  console.log(isTrail)
  const isTrailRef = useRef(isTrail);

useEffect(() => {
  isTrailRef.current = isTrail;
}, [isTrail]);

  const startTokenPayment = (action: Exclude<PaymentAction, null>) => {
    if (paymentActionRef.current || !jwt || !sdkRendered) return;

    paymentActionRef.current = action;
    setPendingAction(action);
    setMessage(null);
    const shouldUseTrial = action === "trial";
    setIsTrail(shouldUseTrial);
    isTrailRef.current = shouldUseTrial;

    try {
      const paymentRequest = EmbeddedPayments.pay(jwt);
      if (paymentRequest && typeof paymentRequest.catch === "function") {
        paymentRequest.catch(() => {
          tokenSuccessCalledRef.current = false;
          clearPaymentAttempt();
          setMessage("Unable to start the payment. Please try again.");
        });
      }
    } catch (error) {
      tokenSuccessCalledRef.current = false;
      clearPaymentAttempt();
      setMessage("Unable to start the payment. Please try again.");
    }
  };

  const isPaymentBusy = pendingAction !== null;
  if (!isOpen) return null;

  return (
    <div className="tailwind-prefix">
            
        <div className="deluxe-subscription-modal__backdrop fixed inset-0 flex items-center justify-center">
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="deluxe-subscription-title"
          aria-busy={isPaymentBusy}
          className="deluxe-subscription-modal__dialog w-full max-w-lg"
        >
      
          {/* Header */}
          <div className="deluxe-subscription-modal__header flex justify-between items-center">
            <div id="deluxe-subscription-title" className="deluxe-subscription-modal__title">
              Subscription Payment
            </div>
            <button
              type="button"
              onClick={onClose}
              disabled={isPaymentBusy}
              aria-label="Close subscription payment"
              className="deluxe-subscription-modal__close"
            >
              ✕
            </button>
          </div>
          <div className="deluxe-subscription-modal__subtitle">
            Choose a payment method to complete your subscription
          </div>
          <div className="deluxe-subscription-modal__body">
        
        <Tabs onValueChange={(e)=>{
          if (isPaymentBusy) return;
          console.log(e)
          setSelectedTab(e)
          if(e==="new"){
          console.log(e)
          setIsTrail(false)

            setUseSavedCard(false)
          }else{
            setUseSavedCard(true)
          }
        }} value={selectedTab} defaultValue={useSavedCard && savedCard[0]? "saved" : "new"} className="deluxe-subscription-modal__tabs">
       {savedCard[0]? <TabsList  className="deluxe-subscription-modal__tab-list grid w-full grid-cols-2">
         
         <TabsTrigger value="saved" className="deluxe-subscription-modal__tab" disabled={!savedCard[0] || isPaymentBusy}>
           <CreditCard className="w-4 h-4 mr-2" />
           Saved Cards
         </TabsTrigger>
         <TabsTrigger disabled={isPaymentBusy} className="deluxe-subscription-modal__tab" value="new">
           <Plus className="w-4 h-4 mr-2 " />
           Add New Card
         </TabsTrigger>
       </TabsList>:<TabsList  className="deluxe-subscription-modal__tab-list grid w-full grid-cols-1">
         
    
         <TabsTrigger disabled={isPaymentBusy} className="deluxe-subscription-modal__tab" value="new">
           <Plus className="w-4 h-4 mr-2 " />
           Add New Card
         </TabsTrigger>
       </TabsList>}
       

        <TabsContent  value="saved" className="deluxe-subscription-modal__tab-content">
          {savedCard[0] ? (
            <SavedCardsList
              trialEligible={trialEligible}
              pendingAction={pendingAction}
              disabled={isPaymentBusy}
              onSubcribe={(paymentId:any,isTrail:any)=>{
              subscribeWithSavedCard(paymentId,isTrail)
              }}
              savedCard={savedCard}
            />
           
          ) : (
            <div className="text-center text-gray-500 py-8">
              No saved cards available
            </div>
          )}
        </TabsContent>

        <TabsContent onClick={()=>{
          if (!isPaymentBusy) setUseSavedCard(false)
        }} value="new" className="deluxe-subscription-modal__tab-content">
        <div className={`deluxe-subscription-modal__secure-card ${sdkRendered ? "is-ready" : "is-loading"}`}>
          <div
              id="embeddedpayments"
              className={`${sdkRendered ? "opacity-100" : "opacity-0"} transition-opacity`}
            />
        </div>
            <div className="deluxe-subscription-modal__actions">
            {sdkRendered && trialEligible && <OutlineButton
              aria-busy={pendingAction === "trial"}
              disabled={isPaymentBusy}
              onClick={() => startTokenPayment("trial")}
              variant={'ghost'} className="deluxe-subscription-modal__action deluxe-subscription-modal__action--secondary w-full">
              {pendingAction === "trial" ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Processing trial...</> : "Subscribe with 30 days trial"}
              </OutlineButton>}
              {sdkRendered && <Button
                aria-busy={pendingAction === "payNow"}
                disabled={isPaymentBusy}
                onClick={() => startTokenPayment("payNow")}
                className="deluxe-subscription-modal__action deluxe-subscription-modal__action--primary w-full"
              >
        {pendingAction === "payNow" ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Processing payment...</> : "Pay now & Start Subscription"}
      </Button>}
            </div>
            {!sdkRendered && <PaymentShimmer />}
        </TabsContent>
      </Tabs>

         
        </div>

        {/* BODY */}
   

        {message && (
          <Alert style={{ marginTop: 15 }} variant="danger">
            <strong>{message}</strong>
          </Alert>
        )}
         
            <div className="deluxe-subscription-modal__summary">
          <div className="deluxe-subscription-modal__summary-row flex justify-between">
            <span>Subscription Plan</span>
            <strong>{plan.plan}</strong>
          </div>
          <div className="deluxe-subscription-modal__summary-row deluxe-subscription-modal__summary-row--total flex justify-between">
            <span>Total</span>
            <strong>{plan.price}/{plan.interval}</strong>
          </div>
        </div>
      
        </div>
      </div>

    </div>
  );
};

const PaymentShimmer = () => {
  return (
    <div className="space-y-4 animate-pulse  w-full">
      <div className="h-10 bg-gray-200 rounded-lg" />
      <div className="h-10 bg-gray-200 rounded-lg" />
      <div className="h-10 bg-gray-200 rounded-lg" />
      <div className="grid grid-cols-2 gap-3 mt-4">
        <div className="h-12 bg-gray-200 rounded-lg" />
        <div className="h-12 bg-gray-200 rounded-lg" />
      </div>
      <div className="h-14 bg-gray-300 rounded-xl mt-6" />
    </div>
  );
};

export default DeluxeSubscriptionModal;
